@if (selectedChannel() === PriceChannel.PUBLIC && conditions()?.length) {
  <div class="contract-select mb-4">
    <p class="font-bold mt-3 mb-2">{{ 'plp.contracts' | cxTranslate }}</p>
    @if (hasMatchingContract() && conditions().length > 1) {
      {{ contractFromCartApi() }}
      @if (!!selectedContractName) {
        ({{ selectedContractName }})
      }
    }

    @if (conditions().length === 1 && (!contractFromCartApi() || hasMatchingContract())) {
        {{ conditions()[0]?.contractId }}
      @if (conditions()[0]?.contractName) {
        ({{ conditions()[0]?.contractName }})
      }
    }

    @if (!contractFromCartApi() && conditions().length > 1) {
      <div [class.row]="rowView()">
        <div [class.col-md-6]="rowView()">
          <app-contract class="w-100" [conditions]="conditions()" (contractSelectedEvent)="showSelectedContract($event)" />
        </div>
      </div>
    }

    <!-- Contract Price Group -->
    @if (contractSelected?.priceGroups?.length > 1 || showPriceGroup()) {
      <div [class.row]="rowView()">
        <div [class.col-md-6]="rowView()">
          <p class="font-bold mt-3 mb-2">{{ 'plp.priceGroup' | cxTranslate }}</p>
          <app-contract-price-group [priceGroup]="priceGroupToShow()" (priceGroupSelectedEvent)="showSelectPriceGroup($event)" />
        </div>
      </div>
    }
  </div>
}
